module.exports = __webpack_public_path__ + "img/e.fc11fc63.png";